import React, { ReactNode, useEffect, useState } from "react";

import { TbProgress, TbTargetArrow } from "react-icons/tb";
import { MdTaskAlt } from "react-icons/md";

import { IProject } from "../../data_models/project";

import { IoWalletOutline } from "react-icons/io5";
import { EmployerWallet } from "../../data_models/employerWallet";
import useCurrentUser from "../../hooks/useCurrentUser";



interface EmployerDashboardOverviewProps {
    projectDrafts: IProject[];
    projectsOngoing: IProject[];
    projectsCompleted: IProject[];
}

const EmployerDashboardOverview = ({
    projectDrafts,
    projectsOngoing,
    projectsCompleted,
}: EmployerDashboardOverviewProps) => {

    const [draftProjects, setDraftProjects] = useState<IProject[]>([]);
    const [ongoingProjects, setOngoingProjects] = useState<IProject[]>([]);
    const [completedProjects, setCompletedProjects] = useState<IProject[]>([]);

    const { wallet } = useCurrentUser();
    const [availableCredits, setAvailableCredits] = useState<number>(0);

    useEffect(() => {


        setDraftProjects(projectDrafts);

        setOngoingProjects(projectsOngoing);
        setCompletedProjects(projectsCompleted);
    }, [
        projectDrafts,
        projectsOngoing,
        projectsCompleted,
    ]);

    useEffect(() => {
        setAvailableCredits((wallet as EmployerWallet)?.totalCredits - (wallet as EmployerWallet)?.totalOccupiedCredits || 0);
    }, [
        wallet,
    ]);

    return (
        <div className="">
            <p className="body1 font-bold">Overview</p>
            <div className="flex flex-wrap gap-4">

                <OverviewCard
                    number={draftProjects.length}
                    title="Draft Projects"
                    icon={<TbTargetArrow className="w-12 h-12" />} />

                <OverviewCard
                    number={ongoingProjects.length}
                    title="Ongoing Projects"
                    icon={<TbProgress className="w-12 h-12" />} />

                <OverviewCard
                    number={completedProjects.length}
                    title="Completed Projects"
                    icon={<MdTaskAlt className="w-12 h-12" />} />

                <OverviewCard
                    number={availableCredits}
                    title="Wallet"
                    icon={<IoWalletOutline className="w-12 h-12" />}
                    caption={`Hrs`}
                />

            </div>
        </div >
    );
};


interface OverviewCardProps {
    number: number;
    title: string;
    icon: ReactNode;
    caption?: string;
    captionIcon?: ReactNode;
}


const OverviewCard: React.FC<OverviewCardProps> = ({ number, title, icon, caption, captionIcon }) => {

    return <div className="border border-neutral-200 rounded-lg w-72 h-52 p-6 flex flex-col">
        <div className={`flex flex-row justify-between ${caption ? 'items-start' : 'items-center'}`}>
            <div>
                <h2 className="font-bold text-secondary-300">{number}</h2>
                {caption && <p className="body2 font-bold text-secondary-300">{caption}</p>}
            </div>
            <div className="flex justify-center items-center bg-secondary-100 w-14 h-14 rounded-full">
                {icon}
            </div>
        </div>
        <div className="mt-auto">
            <p className="body2">{title}</p>

        </div>
    </div >;
};



export default EmployerDashboardOverview;